const combineRouter = {
  path: '/combine',
  name: 'Combine',
  redirect: '/combine/order',
  component: () => import('@/layout/combineHeader'),
  children: [
    {
      path: 'order',
      name: 'Order',
      meta: { title: '订单合并支付' },
      component: () => import(/* webpackChunkName: "combine" */ '@/pages/combine'),
    }
  ]
}

export default combineRouter
